import app from '@/app';
/* @ngInject */
const RoleResource = abstractResource => abstractResource('role');

app.factory('Role', RoleResource);
